export default __webpack_public_path__ + "static/media/te5.4ccde167.png";